export default "__VITE_ASSET__d2729c41__"